<template>
  <el-container :class="{'pageSm':!isBigPage}">
    <i class="ar_img el-icon-s-unfold zhankaiIcon" @click="changeMunuBig" v-if="!isBigPage"></i>
    <el-aside class="animate" :width="asideMaxWidth" style="max-width:200px" v-if="isBigPage">
      <page-nav :isBigPage="isBigPage" :collpanHeight="headerHeight" :isOpenMenu="isOpenMenu" @changeMunuBig="changeMunuBig"></page-nav>
    </el-aside>
    <el-drawer custom-class="nav_drawer" v-else :with-header="false" :visible.sync="isOpenMenu" size="40%" :direction="direction">
      <page-nav :collpanHeight="headerHeight" @changeMunuBig="changeMunuBig"></page-nav>
    </el-drawer>
    <el-container>
      <el-header :height="headerHeight">
        <page-head></page-head>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import pageHead from "@/components/pageHead";
import pageNav from "@/components/pageNav";
export default {
  name: "index",
  components: {
    "page-head": pageHead,
    "page-nav": pageNav,
  },
  data() {
    return {
      //this.$t.locale
      direction:this.$i18n.locale=='ar'?'rtl':'ltr',
      //rtl
      initSet:{
        asideMaxWidth:'15%',
        asideMinWidth:'80px',
        headerHeight:'80px',
      },
      screenWidth:'',
      isBigPage:true,//大屏幕样式（pc）小屏幕（移动端）
      asideMaxWidth:'15%',
      headerHeight:'80px',
      isOpenMenu:true,//是否展开菜单
    };
  },
  watch:{
    screenWidth:{
      handler(val) {        
        if(val>767){
          this.isBigPage=true;
          this.headerHeight=this.initSet.headerHeight;
          if(this.isOpenMenu){
            this.asideMaxWidth=this.initSet.asideMaxWidth;
          }else{
            this.asideMaxWidth=this.initSet.asideMinWidth;
          }
        }else{
          this.isBigPage=false;
          this.asideMaxWidth='0';
          this.headerHeight='60px';
        }
      },
      //immediate: true
    }

  },
  computed: {
    
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    console.log(this.screenWidth);
    //this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        //this.screenHeight = document.body.clientHeight;
      })();
    };
  },
  methods: {
    changeMunuBig() {
     
     if(this.isBigPage){
       //pc
       if(this.isOpenMenu){
          this.isOpenMenu=false;
          this.asideMaxWidth='80px';
       }else{         
          this.isOpenMenu=true;
          this.asideMaxWidth=this.initSet.asideMaxWidth;
       }
     }else{
       console.log(this.isBigPage)
       if(this.isOpenMenu){
          this.isOpenMenu=false;
          this.asideMaxWidth='0';
       }else{         
          this.isOpenMenu=true;
          this.asideMaxWidth='80px';
       }
     }
    }
  },
  created() {
    
  }
};
</script>
<style>
  .nav_drawer{    
    background-color: #008AFF !important;
    color: #fff;
    text-align: center;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    max-width: 150px;
  }
</style>
<style lang="less" scoped>
p{
  padding: 0;
  margin: 0;
  list-style: none;

}
  
  .el-container{
    height: 100%;
  }
  .el-header{
    color: #282828;
  }
  .el-main{
    padding: 16px 40px 16px 16px;
    background-color: #F6F7F9;
  }
  
/* NAV */
  .el-aside {
    background-color: #008AFF;
    color: #fff;
    text-align: center;
    height: 100%;
    /* padding-bottom: 100px; */
    box-sizing: border-box;
    position: relative;
    z-index: 2;
  }
  
 
.zhankaiIcon{
  font-size: 30px;
  position: fixed;
  left: 0;
  bottom: 65px;
  padding: 5px;
  background-color: #008AFF;
  color: #fff;
  border-radius: 50%;
  z-index: 99;
}
.animate{
  transition:width .15s;
}
.ar{
  .zhankaiIcon{
    right: 0;
    left: initial;
  }
}
@media screen and (max-width: 767px){
  .el-main{
    padding: 5px;
  }
  .el-header{
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AppIndex.vue